module.exports = __webpack_public_path__ + "img/personWatch.433da0b8.png";